export default "__VITE_ASSET__BqXmArLB__"